<template>

   <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
       <v-card>
           <v-toolbar dark color="primary" style="position: sticky; top: 0; z-index: 1">
               <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
               <v-toolbar-title>Geração de NFS-e</v-toolbar-title>
               <v-spacer></v-spacer>
               <v-toolbar-items>
                   <v-btn dark text @click="consultar()">Consultar</v-btn>
                   <v-btn dark text @click="save" :disabled="selectedItems.length == 0">Gerar</v-btn>
               </v-toolbar-items>
           </v-toolbar>

           <v-card-text class="mt-5">
               <v-form id="formGerarNFSe" ref="formGerarNFSe" v-model="valid" lazy-validation >
                   <v-row>
                       <v-col cols="12" md="2">
                        <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                            <template v-slot:activator="{on}">
                              <v-text-field type="date" v-model="filtro.vencimentoInicial" label="Vencimento Inicial" dense outlined>
                                <template v-slot:prepend>
                                  <v-icon v-on="on">mdi-calendar</v-icon>
                                </template>
                              </v-text-field>
                            </template>
                            <v-date-picker locale="pt-br" v-model="filtro.vencimentoInicial" no-title/>
                          </v-menu>
                       </v-col>
                       <v-col cols="12" md="1" class="body-1" align="center">
                         até
                       </v-col>
                       <v-col cols="12" md="2">
                        <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                            <template v-slot:activator="{on}">
                              <v-text-field type="date" v-model="filtro.vencimentoFinal" label="Vencimento Final" dense outlined>
                                <template v-slot:prepend>
                                  <v-icon v-on="on">mdi-calendar</v-icon>
                                </template>
                              </v-text-field>
                            </template>
                            <v-date-picker locale="pt-br" v-model="filtro.vencimentoFinal" no-title/>
                          </v-menu>
                       </v-col>
                       <v-col cols="12" md="7">
                        <v-col cols="12" md="12">
                          <v-autocomplete v-model="filtro.doadorId" :items="doadores" :loading="isDoadorLoading" :search-input.sync="searchDoador" hide-no-data hide-selected cache-items clearable
                              item-text="cpfCnpjNome" item-value="id" label="Doador" dense outlined/>
                        </v-col>
                       </v-col>
                   </v-row>
               </v-form>

               <v-data-table id="tabela" :headers="headers" :items="receitas" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1"
                 v-model="selectedItems" show-select>
            
                  <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
                      <v-checkbox hide-details class="mt-0" :value="isSelected" @change="select($event)" @input="select($event)" :disabled="item.isRemessaGerada" />
                  </template>

                  <template v-slot:[`item.situacao`]="{ item }">
                    <v-chip :style=" item.situacao === 'A' ? 'background: var(--v-chipYellow-base) !important' : item.situacao === 'P' ? 'background: var(--v-chipGreen-base) !important' : 'background: var(--v-chipRed-base) !important'">
                      <span style="font-weight: bold" :style=" item.situacao === 'A' ? 'color: var(--v-chipFontYellow-base) !important' : item.situacao === 'P' ? 'color: var(--v-chipFontGreen-base) !important' : 'color: var(--v-chipFontRed-base) !important'">
                        {{item.situacao === "A" ? "Aberto" : item.situacao === "P" ? "Pago" : "Cancelado"}}
                      </span>
                    </v-chip>
                  </template>

                  <template v-slot:[`item.dataVencimento`]="{ item }">
                    {{new Date(item.dataVencimento).ddmmyyyy()}}
                  </template>

                  <template v-slot:[`item.dataPagamento`]="{ item }">
                    {{ item.dataPagamento ? new Date(item.dataPagamento).ddmmyyyy() : ''}}
                  </template>

                  <template v-slot:[`item.valor`]="{ item }">
                    {{item.valor.toMoeda()}}
                  </template>

                  <template v-slot:[`item.desconto`]="{ item }">
                    {{item.desconto.toMoeda()}}
                  </template>

                  <template v-slot:[`item.juros`]="{ item }">
                    {{item.juros.toMoeda()}}
                  </template>

                  <template v-slot:[`item.valorFinal`]="{ item }">
                    {{item.valorFinal.toMoeda()}}
                  </template>

                </v-data-table>

           </v-card-text>
       </v-card>

       <v-overlay :value="salvando">
           <v-progress-circular indeterminate size="64"></v-progress-circular>
       </v-overlay>

   </v-dialog>

</template>
<script>

import NFSeService from '@/core/services/fiscal/NFSeService';
import RecebivelService from '@/core/services/financeiro/RecebivelService';
import DoadorService from '@/core/services/doacao/DoadorService';

export default {
   props:{
       item: {
           required: true
       },
       value: {}
   },
   watch: { 
       item: function() { 
           if ('formGerarNFSe' in this.$refs){
               this.$refs.formGerarNFSe.resetValidation();
               this.log = '';
           }
       },
       value: function() {
           this.dialog = this.value;
       },
       searchDoador (val) {
            if (this.isDoadorLoading) return;
            if (!val) return;
            // if (val.length < 3 ) return;
            
            this.isDoadorLoading = true
            let doadorService = new DoadorService();
            doadorService.AutoComplete(val)
                .then(
                    res => {
                        this.doadores = res.data;
                    },
                    err => this.$swal('Aviso', err.response.data, 'error')
                )
                .finally(() => (this.isDoadorLoading = false))
        },
       dialog: function() {
           if (!this.dialog) {
               this.$emit('fechou');
           }
       }
   },
   data: () => ({
       service: new NFSeService(),
       serviceRecebivel: new RecebivelService(),
       mskMesAno: process.env.VUE_APP_MSK_MESANO,
       valid: true,
       dialog: false,
       isDoadorLoading: false,
       isLoading: false,
       fieldRules: [
           v => !!v || 'Campo obrigatório'
       ],
       options: {
        itemsPerPage: -1
       },
       headers: [
        { text: '', value:'actions', sortable: false  },
        { text: 'Código', value: 'id', type: 'number' },
        { text: 'Doador', value: 'doador.nome' },
        { text: 'Sit.', value: 'situacao' },
        { text: 'Vencimento', value: 'dataVencimento', type: 'date' },
        { text: 'Pagamento', value: 'dataPagamento', type: 'date' },
        { text: 'Valor', value: 'valor', type: 'number' },
        { text: 'Projeto', value: 'projetoId', type: 'number' },
        { text: 'Descrição', value: 'descricao'},
       ],
       filtro: {
         bancoId: null,
         formaPagamentoId: null,
         doadorId: null,
         emissaoNota: 'SIM',
         projetoId: null,
         regiaoId: null,
         pessoalId: null,
         vencimentoInicial: '',
         vencimentoFinal: '',
         pagamentoInicial: '',
         pagamentoFinal: '',
         situacao: 'A',
         codigoInicio: null,
         codigoFim: null
       },
       sessionApp: {},
       totalLista: 0,
       selectedItems: [],
       receitas: [],
       doadores: [],
       loading: false,
       searchDoador: null,
       log: '',
       salvando: false
   }),
   methods: {
      consultar(){
         this.loading = true;
         const { sortBy, sortDesc, page, itemsPerPage } = this.options

         this.serviceRecebivel.ListarComFiltro(page, itemsPerPage, sortBy, sortDesc, this.search, this.headers, this.filtro, "Doador")
            .then(
               res => {
                  this.receitas = res.data.items; 
                  this.totalLista = res.data.count;
                  this.loading = false;
                  this.selectedItems = [];
               },
               err => {
                  this.loading = false;
                  this.$swal('Aviso', err.response.data, 'error')
               }
          );
      },
      save() {

         if (this.$refs.formGerarNFSe.validate()) {

            let ids = this.selectedItems.map((x) => x.id);
               
            this.salvando = true;
            this.log = '';
            this.isLoading = true;
            this.service.Gerar(ids).then(
                res => {
                    this.$swal('Aviso', res.data, res.status == 201 || res.status == 200 ? 'success' : 'warning');
                    this.$emit('salvou');
                    this.valid = false;
                    this.isLoading = false;
                    this.receitas = [];
                    this.selectedItems = [];
                    this.close();
                }, 
                err =>  {
                    if (err.response.status == 400) {
                        this.$swal('Aviso', err.response.data.title, 'warning');
                    }
                    else {
                        this.$swal('Aviso', err.response.data, 'error');
                    }

                    this.isLoading = false;
                }
            ).finally(() => {
                this.salvando = false;
            });

            this.valid = false;
         }

       },
       close() {
           this.dialog = false;
       }
   },
   beforeUpdate(){
       if (!this.dialog){
           this.$emit('fechou');
       }
   },
   mounted() {

   }
}
</script>